import {
	cookieName,
	channelCookieName,
	readChannelCookieString,
	getChannelCookieString,
	readCookieString,
	generateCookie,
	isMatchingWeight,
	updateWeight,
} from "@/common/experiments";

import {
	getBucketId,
	getBucketConfig,
	readBucketConfigFromLocalStorage,
	getBucketConfigOverrides,
} from "@/common/feature-toggling";

import {
	readSavedWords,
	readSortResults,
	readDictionary,
	readFilter,
	getDefaultDictionariesByPage,
} from "@/common/functions";

import { DEFAULT_SORT_RESULTS } from "@/common/consts";

export function mounted() {
	this.detectAdBlocker();
}

function testExpRedis() {
	console.clear();

	const data = {
		date: "150101",
		oldChannels: {
			A: 25,
			B: 25,
			C: 25,
			D: 25,
		},
	};

	const l = {
		initial: {},
		final: {},
		redistributions: {},
	};

	this.$cookies.set(
		channelCookieName,
		getChannelCookieString(data.oldChannels),
		-1
	);

	for (var i = 0; i < 1000; i++) {
		const startCookieData = readCookieString(
			generateCookie(null, data.oldChannels)
		);
		startCookieData.weight = data.oldChannels[startCookieData.channel];
		const startChannel = startCookieData.channel;
		l.initial[startChannel] = l.initial[startChannel]
			? l.initial[startChannel] + 1
			: 1;

		const isMatch = isMatchingWeight(startCookieData);
		let newCookieData;
		if (isMatch) {
			newCookieData = Object.assign({}, startCookieData);
		} else {
			newCookieData = updateWeight(startCookieData, data.oldChannels);
		}

		const newChannel = newCookieData.channel;
		l.final[newChannel] = l.final[newChannel] ? l.final[newChannel] + 1 : 1;

		if (startChannel !== newChannel) {
			const redisKey = `${startChannel}_to_${newChannel}`;
			l.redistributions[redisKey] = l.redistributions[redisKey]
				? l.redistributions[redisKey] + 1
				: 1;
		}

		l.oldChannels = getChannelCookieString(data.oldChannels);
		l.newChannels = getChannelCookieString();
	}

	console.log(l);
}

export function created() {
	if (window.__TEST__ !== true) {
		// Change this value to 1 if you want to run the test.
		if (0) {
			const boundTest = testExpRedis.bind(this);
			boundTest();
		}

		const expCookie = this.$cookies.get(cookieName);
		let cookieData = readCookieString(expCookie);
		if (cookieData === null) {
			this.$cookies.set(cookieName, generateCookie(), -1);
			this.$cookies.set(channelCookieName, getChannelCookieString(), -1);
			cookieData = readCookieString(this.$cookies.get(cookieName));
		}

		if (!isMatchingWeight(cookieData)) {
			const channelCookie = this.$cookies.get(channelCookieName);
			const oldChannels = readChannelCookieString(channelCookie);
			cookieData = updateWeight(cookieData, oldChannels);
			this.$cookies.set(
				cookieName,
				generateCookie(cookieData.channel),
				-1
			);
			this.$cookies.set(channelCookieName, getChannelCookieString(), -1);
			cookieData = readCookieString(this.$cookies.get(cookieName));
		}

		this.$store.commit("loadExperiments", cookieData);
		if (this.$ga) {
			this.$ga.set("dimension2", `v_${cookieData.channel}`);
		}
		window[cookieName] = cookieData;

		this.checkLastVisited();

		// load query filters & dictionary
		const defaultDictionary = getDefaultDictionariesByPage(
			this.$store.getters.getCurrentPage
		);
		const dictionary = readDictionary(defaultDictionary);

		const sortResults = readSortResults().length
			? readSortResults()[0].sortResults
			: DEFAULT_SORT_RESULTS;

		const bonuspoints = readFilter().length
			? readFilter()[0].bonuspoints
			: null;

		const queryFilters = {
			dictionary,
			sortResults,
			bonuspoints,
		};
		this.$store.commit("loadFilters", queryFilters);
	}

	this.onWindowResize(); // Set the current window size.
	if (typeof window.__PRERENDER_INJECTED === "undefined") {
		window.addEventListener("resize", this.onWindowResize);
		this.onWindowResize();

		window.addEventListener("scroll", this.onWindowScroll);
		this.onWindowScroll();
	}

	this.$store.commit("setLoadingSavedWords", true);
	this.$store.commit("loadSavedWords", readSavedWords());
	this.$store.commit("setLoadingSavedWords", false);

	if (typeof window.__PRERENDER_INJECTED === "undefined") {
		const currentConfig = readBucketConfigFromLocalStorage();
		if (currentConfig !== null) {
			this.$store.commit(
				"SET_FEATURE_TOGGLE_BUCKET_CONFIG",
				currentConfig
			);
		}

		this.$store.commit(
			"SET_FEATURE_TOGGLE_BUCKET_OVERRIDES",
			getBucketConfigOverrides()
		);
		getBucketConfig()
			.then((config) => {
				this.$store.commit("SET_FEATURE_TOGGLE_BUCKET_CONFIG", config);

				const toggles = config?.toggles || [];

				if (this.$ga) {
					const bucketId = getBucketId();
					const dimensionStr = `${
						bucketId ? `${bucketId}:` : ""
					}${toggles.join(",")}`;
					this.$ga.set("dimension4", dimensionStr);
					this.$ga.set("metric1", bucketId);
				}
			})
			.catch(({ message, data }) => {
				console.error(message, data);
			});
	}

	if (
		typeof window.__PRERENDER_INJECTED === "undefined" &&
		typeof window.__TEST__ === "undefined"
	) {
		// Check if the user is a usual user. If a cookie cannot be found, start the timer to set the cookie.
		// const usualUserCookie = this.$cookies.get("wf_usual_user");
		// if(this.$ga) this.$ga.set("dimension3","casual");
		// if(usualUserCookie){
		//     this.$store.commit("setUsualUser");
		//     if(this.$ga) this.$ga.set("dimension3","usual");
		// } else {
		//     this.usualUserTimer = setTimeout(() => {
		//         this.$cookies.set("wf_usual_user",Date.now(),-1);
		//         this.$store.commit("setUsualUser");
		//         if(this.$ga) this.$ga.set("dimension3","usual");
		//     }, 60000);
		// }
	}
}

export function destroyed() {
	if (typeof window.__PRERENDER_INJECTED === "undefined") {
		window.removeEventListener("resize", this.onWindowResize);
		window.removeEventListener("scroll", this.onWindowScroll);
	}
}
